import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { Answer } from './faq';

export function SeoFaq({
  entries = [],
  title = 'FAQ',
  generateLearnMoreLinks = true,
  learnMoreLinkText = 'Learn more',
  pathname = '',
  titleComponent = 'h2',
  questionComponent = 'h3',
}) {
  if (!entries || !entries.length) return null;

  const Title = titleComponent;
  const Question = questionComponent;

  return (
    <section className="faq text-gray-darker mb-1">
      {title && <Title className="heading-3">{title}</Title>}
      {entries.map(({ question, answer, learnMoreOverride }) => (
        <details key={question}>
          <summary className="py-0_5">
            <Question className="size-16 fw-normal" style={{ display: 'inline' }}>
              {question}
            </Question>
          </summary>
          <Answer
            content={answer}
            learnMoreLink={
              generateLearnMoreLinks
                ? `<a href="${get(learnMoreOverride, 'pathname', pathname)}">${get(learnMoreOverride, 'linkText', learnMoreLinkText)}</a>`
                : ''
            }
            pathname={pathname}
          />
        </details>
      ))}
    </section>
  );
}

SeoFaq.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
    })
  ),
  title: PropTypes.string,
  generateLearnMoreLinks: PropTypes.bool,
  learnMoreLinkText: PropTypes.string,
  pathname: PropTypes.string,
  titleComponent: PropTypes.string,
  questionComponent: PropTypes.string,
};
